/** @graphql cc **/
import gql from 'graphql-tag';

export const GetLicensedProducts = gql`
	query GetLicensedProducts {
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
	}
`;
